import React, { useMemo } from 'react';
import _ from 'underscore';
import { SharedFolder } from 'views/file-sharing/types/shared-folder.type';
import FolderInfo from './folder-info';
import FolderList from './folder-list';
import { Box } from '@mui/material';

type ListFolderProps = {
  folder: SharedFolder | undefined;
  selectFolderId: (folderId: string) => void;
};

const FolderView: React.FC<ListFolderProps> = ({ folder, selectFolderId }) => {
  const handleSelectedFolder = (folderId: string) => {
    selectFolderId(folderId);
  };

  const handleGoBack = () => {
    selectFolderId(folder?.parentFolderId ?? '');
  };

  const subFolders = useMemo(() => {
    return _.chain(folder?.subFolders)
      .filter((subFolder) => !!subFolder.id)
      .sortBy('name')
      .value();
  }, [folder]);

  return (
    <Box display={'flex'} flexDirection={'column'} gap={4}>
      <FolderInfo folder={folder} handleGoBack={handleGoBack} />
      <FolderList folders={subFolders} handleClick={handleSelectedFolder} />
    </Box>
  );
};

export default React.memo(FolderView);
